import Hero from "../components/Hero";
import Experts from "../components/Experts";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <Experts />
      <Footer />
    </>
  );
}
